export default __webpack_public_path__ + "static/us-enterprise-work-better-8aa5b47192c774a632d9a798b80f71da.gif";